
const event = {
  state: {
     addEventDialog: {
        title:'新增事件信息',
        type:'add'
     },
     eventSearch: {
        stdId:''
     },
     eventSearchBtnDisabled: true
  },
  getters:{
    addEventDialog: state => state.addEventDialog,
    eventSearch: state => state.eventSearch,
    eventSearchBtnDisabled: state => state.eventSearchBtnDisabled
  },
  mutations: {
    SET_EVENT_DIALOG_TITLE: (state, type) => {
      if(type === 'add'){
        state.addEventDialog.title = '新增事件信息'
        state.addEventDialog.type = 'add'
      }else{
        state.addEventDialog.title = '编辑事件信息'
        state.addEventDialog.type = 'edit'
      }
    },
    SET_EVENT_SEARCH : (state, payload) => {
       state.eventSearch = payload;
       console.log("eventSearch"+state.eventSearch);
    },
    SET_EVENT_SEARCHBTN_DISABLED : (state, payload) => {
      state.eventSearchBtnDisabled = payload;
    }
  },
  actions: {
     
  }
}

export default event
